<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-help</v-icon>
        <v-toolbar-title>Block Sub Group 2 Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              item-key="name"
              :loading="loading"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.accmType }}</td>
                  <td class="text-xs-left">{{ row.item.blkGrp }}</td>
                  <td class="text-xs-left">{{ row.item.blksGrp1 }}</td>
                  <td class="text-xs-left">{{ row.item.blksGrp2 }}</td>
                  <td class="text-xs-left">{{ row.item.blksGrp2descS }}</td>
                  <td class="text-xs-center">
                    <v-btn text icon color="primary" type="submit" @click.native="doSelect(row.item)">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr></template
              >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'

export default {
  props: {
    blksGrpId: Object
  },
  data() {
    return {
      headers: [
        { text: 'Accumulation Type', value: 'accmType' },
        { text: 'Block Group', value: 'blkGrp' },
        { text: 'Block Sub Group 1', value: 'blksGrp1' },
        { text: 'Block Sub Group 2', value: 'blksGrp2' },
        { text: 'Short Description', value: 'blksGrp2descS' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    blkSubGrp1Id: function (value) {
      this.doInit()
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    doInit() {
      const apiURI = this.menu.getBlkSubGrp2ListByBlkSubGrp1
      if (apiURI) {
        this.loading = true
        const expand = {
          accmType: this.blksGrpId.accmType,
          blkGrp: this.blksGrpId.blkGrp,
          blksGrp1: this.blksGrpId.blksGrp1
        }
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            this.items = []
            const { data } = result.data
            if (data) {
              data.map((blkSubGrp2List) => {
                const convertList = {
                  accmType: blkSubGrp2List.accmType,
                  blkGrp: blkSubGrp2List.blkGrp,
                  blksGrp1: blkSubGrp2List.blksGrp1,
                  blksGrp2: blkSubGrp2List.blksGrp2,
                  blksGrp2descS: blkSubGrp2List.blksGrp2descS
                }
                this.items.push(convertList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doSelect(data) {
      const blksGrp2 = data.blksGrp2
      this.$emit('doAssign', blksGrp2)
      this.$emit('close')
    }
  },
  computed: {
    menu() {
      return this.$store.state.blkParam.menu
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
